<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      :show-save-button="!handeled"
      unit="考勤异常"
      id-key="AttendanceDtsId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.handel"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="具体情况" prop="Remark">
              <el-input size="mini" v-model="data.Remark" placeholder="请填写具体情况"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处理结果" prop="HandleResult">
              <el-link type="primary" :underline="false" @click="toLeave">班主任补点名</el-link>
              <el-radio-group v-model="data.HandleResult" style="margin-left: 10px;">
                <el-radio :label="1">其他正常缺勤</el-radio>
                <el-radio :label="2">异常缺勤</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer" v-if="handeled">
        <slot name="footer">
          <el-button size="small" @click="close">关 闭</el-button>
        </slot>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        AttendanceDtsId: 0,
        Remark: "",
        HandleResult: 1,
      },
      leave: {
        LeaveId: 0,
        SectionId: 0,
        StudentId: null,
        FullName: "",
        TeacherId: null,
        TermId: null,
        StartSectionId: null,
        // StartSection: "",
        EndSectionId: null,
        // EndSection: "",
        StartDate: "",
        EndDate: "",
        ClassId: null,
        GradeId: null,
      },
      current: null,
      api: require("@/api/st/attendance").default,
      isMB: this.$store.state.isMB,
      termList: [],
      handeled: true,
      rules: {
        HandleResult: [{ required: true, message: "请选择处理结果" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {},
    onEditOpened(row) {
      console.log(row);
      this.handeled = row.HandleStatus == 1;
      this.leave.SectionId = row.SectionId;
      this.leave.StartSectionId = row.SectionId;
      this.leave.EndSectionId = row.SectionId;
      this.leave.StudentId = row.StudentId;
      this.leave.FullName = row.FullName;
      this.leave.TeacherId = row.ClassTeacherId;
      this.leave.TermId = row.TermId;
      this.leave.ClassId = row.ClassId;
      this.leave.GradeId = row.GradeId;
      this.leave.StartDate = row.StartTime;
      this.leave.EndDate = row.EndTime;
    },
    onBeforeSave() {
      if (this.data.HandleResult == 0) {
        this.$message.error("请选择处理结果");
        return false;
      }
    },
    toLeave() {
      this.current = this.leave;
      this.close(true);
    },
    onClosed() {
      this.data.Remark = "";
      if (this.current) {
        this.$emit("to-leave", { ...this.current });
        this.current = null;
      }
    },
  },
};
</script>
<style lang="scss">
</style>